import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const SettingsContext = React.createContext();

export const SettingsProvider = ({ initialSettings, children }) => {
    
    const settingsDefaults = {
        defaultDenomination: 25,
        mallCode: '',
        orderingToken: '',
        catalogURL: '',
        mapiUrl: '',
        segmentEnabled: false,
        phoebe: '',
        messagesUrl: '',
        authentication: 'none',
        userPoints: false,
        samsungPay: false,
        samsungPaySID: '',
        americanExpress: true,
        discoverCard: true,
        masterCard: true,
        visa: true,
        sentryDSN: '',
        hasAdmin: false,
        loyalty: {},
        displayProductTitle: true
    };
    const importedSettings = initialSettings || window.drupalSettings || window.BOOTSTRAP_DATA;
    const [settings, setSettings] = useState({...settingsDefaults, ...importedSettings});
    // TODO: Authentication derivations should be moved to the user context.
    const hasAuthentication = ['required', 'optional'].includes(settings.authentication);
    const authenticationRequired = settings.authentication === 'required';
    const authenticationOptional = settings.authentication === 'optional';

    return (
        <SettingsContext.Provider
            value={{
                ...settings,
                setSettings,
                hasAuthentication,
                authenticationRequired,
                authenticationOptional,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
};

SettingsProvider.defaultProps = {
    initialSettings: undefined,
};

SettingsProvider.propTypes = {
    initialSettings: PropTypes.object,
    children: PropTypes.node.isRequired
};

export const useSettings = () => useContext(SettingsContext);
